export const HIGHEST_PREMIUM_DISCOUNT = "HIGHEST_PREMIUM_DISCOUNT";
export const HIGHEST_PREMIUM_DISCOUNT_STREAM = "HIGHEST_PREMIUM_DISCOUNT_STREAM";
export const PREMIUM_DISCOUNT_LAST_UPDATED_TIME = "PREMIUM_DISCOUNT_LAST_UPDATED_TIME";
